// extracted by mini-css-extract-plugin
export default {"cls1":"PaperImages-cls1__6d","cls2":"PaperImages-cls2__9h PaperImages-cls1__6d"};